import * as React from 'react';
import { Fragment } from 'react';
import { BulkDeleteButton } from 'react-admin';
import { ArrowUpward, AttachMoney, LocalOffer } from '@material-ui/icons';
import BulkAction from '../../bulk-action';
import { HOST_TYPES, PRICE_TIER, LICENSE_TYPES } from '../../../constants';

const HostsBulkActionButtons = props => (
  <Fragment>
      <BulkAction 
        type="select"
        source="type"
        sourceName="Type"
        icon={<ArrowUpward />}
        resource="hosts"
        resourceLabel="Hosts"
        options={HOST_TYPES}
        {...props}
      />
      <BulkAction 
        type="select"
        source="price_tier"
        sourceName="Price Tier"
        icon={<AttachMoney />}
        resource="hosts"
        resourceLabel="Hosts"
        options={PRICE_TIER}
        {...props}
      />
      <BulkAction 
        type="select"
        source="license_type"
        sourceName="License Type"
        icon={<LocalOffer />}
        resource="hosts"
        resourceLabel="Hosts"
        options={LICENSE_TYPES}
        {...props}
      />
      {/* default bulk delete action */}
      <BulkDeleteButton {...props} />
  </Fragment>
);

export default HostsBulkActionButtons;